export function getSaveNewCard(state: WtrState) {
  return state?.checkout?.saveNewCard;
}
